
import { GetAdByType } from '~/api/ad';
export default {
  data() {
    return {
      ad: null,
      isFixed: false,
    };
  },

  mounted() {
    this.getAd();
    this.getIsFixed();
  },
  methods: {
    getAd() {
      this.$axios(GetAdByType(11)).then((res) => {
        this.ad = res?.result?.[0] || null;
      });
    },
    getIsFixed() {
      const routeName = this.$route.name;
      if (routeName === 'column') {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
};
